import axios, { AxiosResponse } from 'axios';
import {
  ReportDeleteReq,
  ReportDeleteRes,
  ReportLogReq,
  ReportLogRes,
} from './types';
import { DELETE_REPORT_LOGS, GET_REPORT_LOGS } from './constants';

export const fetchReportLogList = async (
  payload: ReportLogReq
): Promise<AxiosResponse<ReportLogRes>> => {
  const response = await axios.post<ReportLogRes>(GET_REPORT_LOGS, payload);
  return response;
};

export const deleteReportLog = async (
  payload: ReportDeleteReq
): Promise<AxiosResponse<ReportDeleteRes>> => {
  const response = await axios.post<ReportDeleteRes>(
    DELETE_REPORT_LOGS,
    payload
  );
  return response;
};
